// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"357":"da15975c","891":"da15975c"}[chunkId] + ".css";
};